import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import Firebase from "../../../Firebase/Firebase";
import { Form, Select, Input, message } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { useListVals } from "../../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const db = getDatabase(Firebase);
const DistrictsActionLayout = (props) => {
	var db = getDatabase(Firebase);
	const { canAccessModule } = useAuth();
	const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");
	const [form] = Form.useForm();

	const [name, setName] = useState(null);
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [showLoading, setShowLoading] = useState(false);
	const [provinces] = useListVals(ref(db, "talmidsdb/province"));
	const [zones] = useListVals(ref(db, "talmidsdb/zones"));

	const handleCreate = (values) => {
		if (!canCreateAdminConfig) {
			message.error("You do not have permission to create districts.");
			return;
		}
		var objectID = uuidv4();
		var object = values;
		object.id = objectID;
		const output = FireFetch.SaveTODB("district", objectID, object);
		output.then((result) => {
			if (result === "success") {
				FireFetch.addLog("Districts", objectID, "Create");
				message.success("District created successfully");
				setShowLoading(false);
				form.resetFields();
			}
		})
			.catch((error) => {
				message.error(`Unable to create district. An error occurred : ${error.message}`);
				setShowLoading(false);
			})
	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol>
					<Form
						form={form}
						layout="vertical"
						disabled={!canCreateAdminConfig}
						onFinish={handleCreate}
					>
						<Form.Item label="Enter District name"
							name="districtName"
							rules={[{ required: true, message: 'District Name is required' }]}
							className="d-flex flex-column my-2 mt-3">
							<Input
								className="w-100"
								name="text-input-name"
								placeholder="enter district name"
								onChange={(e) => { setName(e.target.value) }}
								value={name}
							/>
						</Form.Item>
						<Form.Item
							label="Enter Country name"
							name="countryID"
							className="d-flex flex-column my-2 mt-3"
							rules={[{
								required: true,
								message: 'Please input Country!'
							}]}
						>
							<Select placeholder="select Country"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}>
								{countries.map((item, index) => (
									<Select.Option value={item.id} key={index}>{item.countryName}</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item
							label="Enter District Province"
							name="provinceID"
							className="d-flex flex-column my-2 mt-3"
							rules={[{
								required: true,
								message: 'Please input Province!'
							}]}
						>
							<Select placeholder="select Province"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}>
								{provinces?.map((item, index) => (
									<Select.Option value={item.id}>{item.provinceName}</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item
							label="Zone"
							name="zoneID"
							rules={[{
								required: true,
								message: 'Please input zone!'
							}]}>
							<Select placeholder="select Zone"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}
							>
								{zones?.map((item, index) => (
									<Select.Option key={index} value={item.id}>{item.zone}</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Button appearance="primary" htmlType="submit" className="mt-2" isLoading={showLoading} disabled={!canCreateAdminConfig}>Add</Button>
					</Form>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default DistrictsActionLayout;
